export function toLogValue(value) {
    if (value === undefined || value === null || value === '')
        return null;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
        return value;
    if (value instanceof Date)
        return value.getTime();
    return String(value); // Decimal and other objects
}
function sameValue(a, b, decimals) {
    if (a === b)
        return true;
    if (a === null || b === null || typeof a === 'boolean' || typeof b === 'boolean')
        return false;
    const na = Number(a);
    const nb = Number(b);
    if (Number.isNaN(na) || Number.isNaN(nb))
        return false;
    return decimals === undefined ? na === nb : na.toFixed(decimals) === nb.toFixed(decimals);
}
/**
 * One item per field whose value really changed. "60" and 60 count as the same value, and with
 * `decimals` so do values that look the same once rounded (1.5228 and 1.52 at 2 decimals).
 */
export function changedItems(prev, next, specs) {
    const items = [];
    for (const { key, ...spec } of specs) {
        const name = key ?? spec.field;
        if (!(name in next))
            continue; // not part of this update
        const oldValue = toLogValue(prev?.[name]);
        const newValue = toLogValue(next[name]);
        if (sameValue(oldValue, newValue, spec.decimals))
            continue;
        items.push({ ...spec, old: oldValue, new: newValue });
    }
    return items;
}
/** A single-value item, or nothing when the value is empty. */
export function valueItem(field, value, extra = {}) {
    const v = toLogValue(value);
    return v === null ? [] : [{ field, value: v, ...extra }];
}
/** Status switch of any list item (active / inactive). */
export function statusItems(oldStatus, newStatus) {
    return changedItems({ status: oldStatus }, { status: newStatus }, [
        { field: 'status', valueKey: 'event.value.status.{value}' },
    ]);
}
/** Spread into details: {...details, ...itemsDetail(items)}. Adds nothing when the list is empty. */
export function itemsDetail(items) {
    return items.length ? { items: JSON.stringify(items) } : {};
}
/** Unit of a regular dose. Same rules as changeDoseUnitLabel in app/src/modules/protocols/functions.ts. */
export function regularDoseUnit(method, doseUnit) {
    const unit = doseUnit ?? '';
    switch (method) {
        case 'BSA':
        case 'BSA30':
            return `${unit}/m²`;
        case 'WEIGHT':
            return `${unit}/kg`;
        case 'AUC':
            return `${unit} * min/ml`;
        case 'VOLUME':
            return 'ml';
        default:
            return unit;
    }
}
//# sourceMappingURL=event-log-items.js.map